/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAccountFromJSON, UserAccountToJSON, } from "./UserAccount";
/**
 * Check if a given object implements the LoginResponse interface.
 */
export function instanceOfLoginResponse(value) {
    if (!("userAccount" in value) || value.userAccount === undefined)
        return false;
    return true;
}
export function LoginResponseFromJSON(json) {
    return LoginResponseFromJSONTyped(json, false);
}
export function LoginResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        userAccount: UserAccountFromJSON(json.userAccount),
    };
}
export function LoginResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        userAccount: UserAccountToJSON(value.userAccount),
    };
}
